import { useLocation } from "react-router-dom";
import { HomeLayout } from "../../layouts";
import { getModuleConfig } from "../../config/modulePageConfig";
import ModuleReportContent from "../Home/ModuleReportContent";

const ModulePage = () => {
  const path = useLocation().pathname;
  const { title } = getModuleConfig(path);

  return (
    <HomeLayout>
      <ModuleReportContent title={title} />
    </HomeLayout>
  );
};

export default ModulePage;
